'use client'; // Remove if not using Next.js App Router

import React, { useEffect } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import heroImage from '../../assets/about.webp'; // e.g., aerial view of Madurai or tour group
import about3 from '../../assets/whatwedo.jpg';     // e.g., happy tourists at Meenakshi Temple
import missionImg from '../../assets/mission.jpg';
import visionImg from '../../assets/vision.jpg';
import assets from '../../assets/assets';
const About = () => {
  const [fadeOut, setFadeOut] = React.useState(false);

  // Add this function inside your About component, before the return statement
const updateArrowVisibility = (container) => {
  const leftArrow = document.getElementById('leftArrow');
  const rightArrow = document.getElementById('rightArrow');
  const cardWidth = container.querySelector('.flex-shrink-0').clientWidth;
  const currentScroll = container.scrollLeft;
  const maxScroll = container.scrollWidth - container.clientWidth;

  // Show/hide left arrow
  if (currentScroll <= 0) {
    leftArrow.style.display = 'none';
  } else {
    leftArrow.style.display = 'flex';
  }

  // Show/hide right arrow
  if (Math.abs(currentScroll - maxScroll) < 1) { // Close to the end
    rightArrow.style.display = 'none';
  } else {
    rightArrow.style.display = 'flex';
  }
};

// Add this useEffect to initialize arrow visibility
React.useEffect(() => {
  const container = document.getElementById('whyShaSingleCarousel');
  if (container) {
    // Initial arrow visibility
    updateArrowVisibility(container);
    
    // Add scroll listener
    const handleScroll = () => updateArrowVisibility(container);
    container.addEventListener('scroll', handleScroll);
    
    // Cleanup
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }
}, []);

  const taglineStyle = {

    color: "white",
    fontFamily: "Playfair, serif",
    fontSize: "clamp(2.8rem, 6vw, 4rem)",
    fontWeight: "bold",
    textAlign: "center",

  };
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage: ` linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url(${heroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '800px',
          display: 'flex',
          fontWeight: 'bold',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: 'white',
        }}
      >
        <div data-aos="fade-up" data-aos-once="true">
          <h1 style={taglineStyle}>
            Crafting journeys that reflect your style, your pace, your dreams, your spirit.
            See the World Your Way.
          </h1>


        </div>
      </section>

      {/* Main Content */}
      <Container className="my-5" style={{ fontFamily: 'sans-serif, sans-serif', lineHeight: '1.8' }}>
        {/* Introduction Section */}
        <section id="introduction" className="mb-5" data-aos="fade-up" data-aos-once="true">
          <h2
            className="text-center mb-4"
            style={{ fontWeight: 'bold', color: 'var(--color-primary)' }}
          >
            Who we are?
          </h2>
          <Row>
            <Col>
              <p style={{ color: 'var(--color-primary)', textAlign: 'justify' }}>
                <span style={{ fontWeight: 'bold', color: 'var(--color-primary)' }}>
                  Sha tours
                </span>{' '}
                is a privately owned, independent tour company—born out of a deep
                passion for travel and a commitment to transforming holidays into stories worth
                telling and memories worth keeping.

                With over two decades of hands-on expertise in the travel industry, we specialize in
                tailor-made journeys and related travel services for both international and domestic
                clients, while considering their style and budget.

                We believe that the perfect holiday doesn’t begin with a booking—it begins with a
                conversation. We listen attentively, advise with integrity, and plan meticulously to
                align every detail with your preferences and expectations.

                Our dedicated team crafts bespoke vacations to the world’s most enchanting
                destinations, designed with a deeply personal touch and deliver exceptional service,
                ensuring every element of your holiday is as unique as you are.
              </p>
            </Col>
          </Row>
        </section>
        <Container className="my-5" >
          {/* Vision Section */}
          <Row className="align-items-center mb-5" data-aos="fade-left">
            <Col md="6" className="order-md-2">
              <img
                src={assets.vision}
                loading="lazy"
                alt="Our Vision"
                style={{
                  width: '100%',
                  borderRadius: '10px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  objectFit: 'cover',
                  height: '320px',
                }}
              />
            </Col>
            <Col md="6" className="order-md-1">

              <p style={{ color: '#040695', textAlign: 'justify' }}>
                Our vision is to be a successful and trusted travel company, built on efficiency,
                integrity, and transparency, and to become the first choice for every traveller by
                delivering reliable service, smart planning, and the best value for both leisure and
                business trips.
              </p>
            </Col>
          </Row>

          {/* Mission Section */}
          <Row className="align-items-center mb-5" data-aos="fade-right">
            <Col md="6">
              <img
                src={assets.mission}
                loading="lazy"
                alt="Our Mission"
                style={{
                  width: '100%',
                  borderRadius: '10px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  objectFit: 'cover',
                  height: '320px',
                }}
              />
            </Col>
            <Col md="6" style={{ textAlign: 'justify' }}>

              <p style={{ color: '#040695' }}>We aim to build lasting relationships by crafting impeccably planned itineraries that
                reflect each client’s unique style. </p>
              <p style={{ color: '#040695' }}>
                Continuously update our knowledge to global travel trends and seamlessly integrate
                them into our service offerings.</p>
              <p style={{ color: '#040695' }}>
                Deliver the highest quality of travel products and services, ensuring customer and
                employee satisfaction while achieving sustainable growth and profitability.</p>
            </Col>
          </Row>


        </Container>
        {/* Our Value Propositions Section */}
        <section className="py-5" data-aos="fade-up" data-aos-once="true">
          <Container>
            <h2
              className="text-center mb-5"
              style={{
                fontWeight: "bold",
                color: "#040695",
              }}
            >
              Our Value Propositions
            </h2>

            {/* FIRST ROW – 1 CENTER CARD */}
            <Row className="justify-content-center mb-4">
              <Col md="6" lg="4">
                <div
                  className="p-4 h-100"
                  style={{
                    background: "white",
                    borderRadius: "15px",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    textAlign: "justify"
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.boxShadow =
                      "0 15px 30px rgba(4, 6, 149, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 20px rgba(0,0,0,0.08)";
                  }}
                >
                  <h4 style={{ fontWeight: "bold", color: "#040695", marginBottom: "1rem" }}>
                    All Under One Roof
                  </h4>
                  <p style={{ color: "#040695", lineHeight: "1.7" }}>
                    From flights and visas to hotels, transfers, guides, and insurance—we handle it all
                    under one roof, giving you a smooth journey with less hassle and a single point of
                    contact.
                  </p>
                </div>
              </Col>
            </Row>

            {/* REMAINING 6 CARDS – 3 + 3 */}
            <Row className="g-4">
              {[
                {
                  title: "Tailored just for you",
                  desc: "Every trip is designed around you—your style, budget, pace, and interests—so your itinerary feels personal, efficient, and truly yours."
                },
                {
                  title: "Experiential Travel",
                  desc: "We go beyond sightseeing with authentic experiences like local walks, tastings, workshops, and cultural encounters that help you connect deeply with each destination."
                },
                {
                  title: "Quality with Care",
                  desc: "With trusted partners, meticulous planning, and personal attention, we ensure your travel is seamless, safe, and consistently enjoyable."
                },
                {
                  title: "Cost-Effective",
                  desc: "By combining contracted rates, smart routing, and transparent pricing, we make sure you get the best value without compromising quality."
                },
                {
                  title: "Timely Response",
                  desc: "Our team responds quickly with clear updates and proactive support, giving you confidence and saving you time at every stage of your journey."
                },
                {
                  title: "Trusted Travel Partner",
                  desc: "Backed by experience, a strong network, and honest communication, we’re the reliable partner you can count on from planning to return."
                },
              ].map((item, index) => (
                <Col md="6" lg="4" key={index}>
                  <div
                    className="p-4 h-100"
                    style={{
                      background: "white",
                      borderRadius: "15px",
                      boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                      transition: "transform 0.3s ease, box-shadow 0.3s ease",
                      textAlign: 'justify'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-10px)";
                      e.currentTarget.style.boxShadow =
                        "0 15px 30px rgba(4, 6, 149, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 6px 20px rgba(0,0,0,0.08)";
                    }}
                  >
                    <h4 style={{ fontWeight: "bold", color: "#040695", marginBottom: "1rem" }}>
                      {item.title}
                    </h4>
                    <p style={{ color: "#040695", lineHeight: "1.7" }}>
                      {item.desc}
                    </p>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

       {/* Why Sha Tours? - Single Centered Card Carousel with Arrows */}
<section className="py-5" data-aos="fade-up" data-aos-once="true">
  <Container>
    <div className="mb-5">
      <h2
        style={{
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#040695',
        }}
      >
        Why Sha tours?
      </h2>
      <p
        style={{
          color: '#040695',
          maxWidth: '800px',
          margin: '0 auto',
          marginTop: '15px',
          textAlign: 'justify'
        }}
      >
        Looking for something more from your vacation? You're in the right place.<br />
        At <strong style={{ color: '#040695' }}>Sha tours</strong>, we believe travel is about
        experiencing a destination, not merely visiting it. That's why we create immersive, meaningful journeys that benefit both travellers and local communities.
      </p>
    </div>

    {/* Single Card Carousel Container */}
    <div className="position-relative">
      {/* Main Carousel Track */}
      <div
        className="d-flex overflow-hidden"
        style={{
          scrollSnapType: 'x mandatory',
          scrollBehavior: 'smooth',
          gap: '0',
          width: '100%',
        }}
        id="whyShaSingleCarousel"
        onScroll={(e) => updateArrowVisibility(e.target)} // Add scroll listener
      >
        {[
                  {
                    title: "25+ Years of Travel Excellence",
                    tagline: "Experience you can trust.",
                    desc: "With over two decades in the travel industry, we’ve perfected the art of seamless journeys. Our experience ensures every detail is managed with care, delivering safe, reliable, and joyful holidays across the globe."
                  },
                  {
                    title: "Your Journey, Your Way",
                    tagline: "Tailor-made just for you.",
                    desc: "No two travellers are alike. We design personalized itineraries—whether it’s a honeymoon, family escape, or spiritual trip—so every journey reflects your tastes, interests, and dreams."
                  },
                  {
                    title: "Value Without Compromise",
                    tagline: "Fair prices, no hidden costs.",
                    desc: "We respect your budget without cutting corners. With transparent pricing and trusted partners, you’ll always know what you’re paying for—affordable, secure, and worth every penny."
                  },
                  {
                    title: "Trusted Guides & Professional Chauffeurs",
                    tagline: "Knowledgeable, friendly, reliable.",
                    desc: "Our expert guides and multilingual chauffeurs ensure your trip is smooth, safe, and enriching. With local know-how and warm service, they turn your journey into an experience to remember."
                  },
                  {
                    title: "Modern, Safe & Reliable Transport",
                    tagline: "Comfort on every ride.",
                    desc: "From luxury coaches to private vehicles, our modern fleet is well-maintained, safe, and designed for comfort—so you travel stress-free, every mile of the way."
                  },
                  {
                    title: "One Stop for All Your Travel Needs",
                    tagline: "Everything under one roof.",
                    desc: "Flights, hotels, visas, meals, sightseeing, forex—we handle it all. From group tours to custom holidays, enjoy complete travel solutions in one place, planned with ease."
                  },
                  {
                    title: "Support Around the Clock",
                    tagline: "We’re here, always.",
                    desc: "Travel with confidence knowing our team is available 24/7—before, during, and after your trip. Whatever comes up, we’re just a call away."
                  },
                  {
                    title: "Honest Guidance You Can Trust",
                    tagline: "Advice with integrity.",
                    desc: "We believe in honest, transparent travel planning. No hidden agendas, no overselling—just genuine advice to help you make the best choices for your journey."
                  },
                  {
                    title: "Responsible Travel, Real Impact",
                    tagline: "Travel that gives back.",
                    desc: "We design journeys that care for local communities and the planet. By supporting responsible tourism, your holiday creates positive impact—preserving cultures, empowering locals, and protecting nature."
                  }

                ].map((item, index) => (
          <div
            key={index}
            className="flex-shrink-0"
            style={{
              width: '100%',
              scrollSnapAlign: 'center',
            }}
          >
            <div
              className="card border-0 shadow-lg h-100 position-relative overflow-hidden mx-auto"
              style={{
                borderRadius: '20px',
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
                transition: 'all 0.4s ease',
                maxWidth: '800px',
                margin: '0 auto',
              }}
            >
              <div
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{
                  background: 'linear-gradient(135deg, rgba(4,6,149,0.03) 0%, rgba(4,6,149,0.01) 100%)',
                  zIndex: 1,
                }}
              />
              <div className="p-5 position-relative" style={{ zIndex: 2 }}>
                <div className="mb-4" style={{
                  textAlign: 'justify',
                  borderRadius: '12px',
                  padding: '0.75rem 1.25rem',
                  display: 'inline-block'
                }}></div>
                <h3 className="fw-bold text-center mb-3" style={{
                  color: '#040695',
                  fontSize: 'clamp(1.8rem, 3vw, 2.2rem)'
                }}>
                  {item.title}
                </h3>
                <h5 className="fw-semibold text-center mb-4" style={{
                  color: '#3a3aff',
                  fontSize: '1.2rem'
                }}>
                  "{item.tagline}"
                </h5>
                <p style={{
                  lineHeight: '1.8',
                  color: '#555',
                  fontSize: '1.05rem'
                }}>
                  {item.desc}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

     {/* Left Arrow - RESPONSIVE */}
<button
  className="carousel-arrow carousel-arrow-left position-absolute top-50 start-0 translate-middle-y border-0 shadow-lg"
  id="leftArrow"
  style={{
    background: 'linear-gradient(135deg, #040695 0%, #3a3aff 100%)',
    color: 'white',
    zIndex: 10,
    borderRadius: '50%',
    width: 'clamp(44px, 5vw, 56px)',
    height: 'clamp(44px, 5vw, 56px)',
    left: 'clamp(-28px, -4vw, -32px)',
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'clamp(1.1rem, 3vw, 1.4rem)',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
    boxShadow: '0 6px 20px rgba(4, 6, 149, 0.3)'
  }}
  onClick={() => {
    const container = document.getElementById('whyShaSingleCarousel');
    if (!container) return;
    
    const cardWidth = container.querySelector('.flex-shrink-0')?.clientWidth || 0;
    const currentScroll = container.scrollLeft;
    
    // Calculate new scroll position - go to previous card
    const cardIndex = Math.round(currentScroll / cardWidth);
    const newScroll = Math.max(0, (cardIndex - 1) * cardWidth);
    
    // Use smooth scrolling
    container.scrollTo({
      left: newScroll,
      behavior: 'smooth' // This ensures smooth scrolling
    });
    
    // Update arrows after scrolling
    setTimeout(() => updateArrowVisibility(container), 300);
  }}
  onMouseEnter={(e) => {
    if (e.target.style.display !== 'none') {
      e.target.style.transform = 'scale(1.1)';
      e.target.style.boxShadow = '0 10px 30px rgba(4, 6, 149, 0.4)';
    }
  }}
  onMouseLeave={(e) => {
    if (e.target.style.display !== 'none') {
      e.target.style.transform = 'scale(1)';
      e.target.style.boxShadow = '0 6px 20px rgba(4, 6, 149, 0.3)';
    }
  }}
>
  ❮
</button>

{/* Right Arrow - RESPONSIVE */}
<button
  className="carousel-arrow carousel-arrow-right position-absolute top-50 end-0 translate-middle-y border-0 shadow-lg"
  id="rightArrow"
  style={{
    background: 'linear-gradient(135deg, #040695 0%, #3a3aff 100%)',
    color: 'white',
    zIndex: 10,
    borderRadius: '50%',
    width: 'clamp(44px, 5vw, 56px)',
    height: 'clamp(44px, 5vw, 56px)',
    right: 'clamp(-28px, -4vw, -32px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'clamp(1.1rem, 3vw, 1.4rem)',
    fontWeight: 'bold',
    transition: 'all 0.3s ease',
    boxShadow: '0 6px 20px rgba(4, 6, 149, 0.3)'
  }}
  onClick={() => {
    const container = document.getElementById('whyShaSingleCarousel');
    if (!container) return;
    
    const cardWidth = container.querySelector('.flex-shrink-0')?.clientWidth || 0;
    const currentScroll = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;
    
    // Calculate new scroll position - go to next card
    const cardIndex = Math.round(currentScroll / cardWidth);
    const newScroll = Math.min(maxScroll, (cardIndex + 1) * cardWidth);
    
    // Use smooth scrolling
    container.scrollTo({
      left: newScroll,
      behavior: 'smooth' // This ensures smooth scrolling
    });
    
    // Update arrows after scrolling
    setTimeout(() => updateArrowVisibility(container), 300);
  }}
  onMouseEnter={(e) => {
    if (e.target.style.display !== 'none') {
      e.target.style.transform = 'scale(1.1)';
      e.target.style.boxShadow = '0 10px 30px rgba(4, 6, 149, 0.4)';
    }
  }}
  onMouseLeave={(e) => {
    if (e.target.style.display !== 'none') {
      e.target.style.transform = 'scale(1)';
      e.target.style.boxShadow = '0 6px 20px rgba(4, 6, 149, 0.3)';
    }
  }}
>
  ❯
</button>
    </div>

    {/* Dots Indicator */}
    <div className="text-center mt-4">
      {Array(9)
        .fill(null)
        .map((_, i) => {
          const container = document.getElementById('whyShaSingleCarousel');
          const isActive = container && Math.round(container.scrollLeft / container.querySelector('.flex-shrink-0').clientWidth) === i;

          return (
            <button
              key={i}
              className="mx-2 p-0 border-0 bg-transparent"
              style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                background: isActive ? '#040695' : '#e0e0e0',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                border: isActive ? '2px solid #040695' : 'none'
              }}
              onClick={() => {
                const container = document.getElementById('whyShaSingleCarousel');
                const cardWidth = container.querySelector('.flex-shrink-0').clientWidth;
                container.scrollTo({
                  left: i * cardWidth,
                  behavior: 'smooth'
                });
              }}
            />
          );
        })}
    </div>
  </Container>
</section>


        {/* Current Offerings */}
        <section className="align-items-center mb-5" >
          <Row>
            <Col md="6" style={{ textAlign: 'justify' }}>
              <h2 style={{ fontWeight: 'bold', color: 'var(--color-primary)' }}>
                What we do?
              </h2>
              <br />
              <p style={{ color: 'var(--color-primary)' }}> At Sha tours, we design travel experiences that go beyond the ordinary. From
                personalized holiday itineraries to seamless business travel arrangements, we bring
                together expertise, creativity, and care to craft journeys that truly reflect your needs.</p>
              <h4 style={{ color: 'var(--color-primary)' }}>We specialize in:</h4><br />
              <p style={{ textAlign: 'justify', color: 'var(--color-primary)' }}>
                <h5>Tailor-Made Holidays  </h5> Curating customized itineraries for honeymoons,
                family vacations, adventure escapes, and cultural explorations.  <br />
                <h5 >Group &amp; Corporate Travel </h5>Organizing smooth and efficient travel solutions
                for meetings, incentives, conferences, and events (MICE).  <br />
                <h5 >Inbound, Domestic &amp; Outbound Tours </h5>  Offering complete travel services
                across India and worldwide, with strong local and international partnerships.  <br />
                Our focus is simple—to create memorable, worry-free journeys with unmatched
                value, reliability, and personal attention.
              </p>

            </Col>
            <Col md="6" className="order-md-2">
              <img
                src={assets.whatwedo}
                alt="Sha tours Current Activities"
                style={{ width: '100%', borderRadius: '10px', height: '100%', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}
              />
            </Col>
          </Row>
          <a href='/services'>
            <button

              onClick={() => {
                setFadeOut(true);
                // match fade duration
              }}

              style={{
                marginTop: "25px",
                padding: "14px 32px",

                borderRadius: "8px",
                backgroundColor: "var(--color-primary)",
                color: "white",
                border: "none",
                cursor: "pointer",
                transition: "0.3s",
              }}
            >
              Learn More
            </button>
          </a>
        </section>
      </Container>
    </div>
  );
};

export default About;